/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser';

/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
    names: {
        signUpSignIn: process.env.REACT_APP_B2C_SUSI,
        // forgotPassword: 'B2C_1_reset_v3',
        // editProfile: 'B2C_1_edit_profile_v2',
    },
    authorities: {
        signUpSignIn: {
            authority: process.env.REACT_APP_B2C_SUSI_AUTHORITY,
        },
        // forgotPassword: {
        //     authority: 'https://devdgb.b2clogin.com/devdgb.onmicrosoft.com/B2C_1_reset_v3',
        //     // authority: 'https://fabrikamb2c.b2clogin.com/fabrikamb2c.onmicrosoft.com/B2C_1_reset_v3',
        // },
        // editProfile: {
        //     authority: 'https://devdgb.b2clogin.com/devdgb.onmicrosoft.com/b2c_1_edit_profile_v2',
        //     // authority: 'https://fabrikamb2c.b2clogin.com/fabrikamb2c.onmicrosoft.com/b2c_1_edit_profile_v2',
        // },
    },
    authorityDomain: process.env.REACT_APP_B2C_AUTHORITY_DOMAIN,
};

// Reeeeeedirect
// https://dgb-frontend-prod.azurewebsites.net/auth-response

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
    auth: {
        // clientId: "5c1e371d-c359-4765-a947-d5166633aa48", // This is the ONLY mandatory field that you need to supply.
        clientId: process.env.REACT_APP_B2C_CLIENT_ID, // This is the ONLY mandatory field that you need to supply.
        authority: b2cPolicies.authorities.signUpSignIn.authority, //"https://devdgb.b2clogin.com/devdgb.onmicrosoft.com/B2C_1_hJ1R-OqKB_LrOg-A968_Xv2b-Ehfm_DRVG-d8F4" // Choose SUSI as your default authority.
        knownAuthorities: [b2cPolicies.authorityDomain], //["https://devdgb.b2clogin.com"] // Mark your B2C tenant's domain as trusted.
        redirectUri: process.env.REACT_APP_B2C_REDIRECT_URL, //['http://localhost:3000/confirm-vehicle'], // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
        postLogoutRedirectUri: process.env.REACT_APP_B2C_LOGOUT_URL,//"https://devdgb.b2clogin.com/devdgb.onmicrosoft.com/B2C_1_hJ1R-OqKB_LrOg-A968_Xv2b-Ehfm_DRVG-d8F4/oauth2/v2.0/logout?post_logout_redirect_uri=https://localhost:3000/initial-quote", // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        // console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};


/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: [],
};


/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
export const silentRequest = {
    scopes: ["openid", "profile"],
    loginHint: "example@domain.net"
};